import { IBienLaiSelectBySinhVienRequest } from "../../../model/request/bien-lai/IBienLaiSelectBySinhVienRequest";
import { IBienLaiThuViewModel } from "../../../model/respone/bien-lai/IBienLaiThu";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IBienLaiViewBaseActionTypes<T> {
  request: IBienLaiSelectBySinhVienRequest;
  data: T;
}
export const eBienLaiViewActionsObj = {
  LOAD_START: {} as IBienLaiSelectBySinhVienRequest,
  LOAD_SUCCESS: {} as IBienLaiViewBaseActionTypes<IBienLaiThuViewModel[]>,
  LOAD_ERRR: {} as IBienLaiViewBaseActionTypes<string>,
};
export const eBienLaiViewActionTypeIds = generateActionTypeIds(
  eBienLaiViewActionsObj,
  "BIEN_LAI_VIEW"
);
export type IBienLaiViewActionTypes = IGenericActionType<
  typeof eBienLaiViewActionsObj,
  "BIEN_LAI_VIEW"
>;
